import { render } from "./DeletedStories.vue?vue&type=template&id=84a51f4e&lang=html"
import script from "./DeletedStories.vue?vue&type=script&lang=js"
export * from "./DeletedStories.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__